import lazyPage from "../../../../../../common/helpers/lazyPage";

export default lazyPage(
    "src/front/components/Task/types/Chords3/editor/chords3editor.tsx",
    () => import("./chords3editor"),
);
